import { AlertTriangle } from "lucide-react";
import { Spinner } from "../../../components/ui/spinner";
import { useTranslation } from "react-i18next";

type Props = {
  message?: string | null;
  isReconnecting: boolean;
  canReconnect: boolean;
  onReconnect: () => void;
};

const NeedsAttentionBanner = ({
  message,
  isReconnecting,
  canReconnect,
  onReconnect,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className="mx-6 mb-4 mt-4 rounded-[8px] border border-amber-500/30 bg-amber-500/10 p-3">
      <div className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 size-4 shrink-0 text-amber-500" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-foreground">
            {t("mcpPage.reauthorization.title")}
          </p>
          <p className="mt-0.5 text-xs text-muted-foreground">
            {message ||
              t("mcpPage.reauthorization.description")}
          </p>
          <button
            type="button"
            onClick={onReconnect}
            disabled={!canReconnect || isReconnecting}
            aria-busy={isReconnecting}
            className="mt-2 flex h-8 items-center gap-2 rounded-md bg-amber-500 px-3 text-sm font-medium text-amber-950 transition-colors hover:bg-amber-400 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isReconnecting && <Spinner className="size-3.5" />}
            {isReconnecting ? t("mcpPage.actions.connecting") : t("mcpPage.actions.reconnect")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NeedsAttentionBanner;
